<template>
    <v-sheet>
        <template v-if="points?.length">
            <v-data-table v-bind="{ items, headers }" disable-filtering disable-pagination disable-sort hide-default-footer :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" total-visible="11" color="primary" @input="search" />
        </template>
        <template v-else>
            <p class="page-text grey-6--text text-center">
                안녕하세요, 담당자님. <br />
                포인트 내역이 없습니다.
            </p>
        </template>
    </v-sheet>
</template>

<script>
import api from "@/api";

const headers = [
    { width: 164, text: "지급/사용일시", value: "createdAt", formatter: (value) => value?.toDateTime?.() || value || "-" },
    { width: 480, text: "비고", value: "remark" },
    { width: 115, text: "포인트", value: "amount", formatter: (value) => (value?.format?.() || 0) + "원", align: "end" },
    { width: 115, text: "잔여포인트", value: "remain", formatter: (value) => (value?.format?.() || 0) + "원", align: "end" },
].map((item, index, array) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-") }));

export default {
    data: () => ({
        points: [],

        page: 1,
        limit: 10,
        summary: { totalCount: 0 },

        headers,

        loading: false,
    }),
    computed: {
        items() {
            return [...this.points];
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            return {};
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { skip, limit, params } = this;
                const { summary, points } = await api.v1.me.points.gets({
                    headers: { skip, limit },
                    params,
                });

                this.points = points;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .white-space-pre-line {
        white-space: pre-line;
    }
}
</style>